import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import base_url from '../config/Config';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import PageLoader from '../components/PageLoader';

const ViewFintech = () => {
    const navigate = useNavigate();
    const [fintechPartners, setFintechPartners] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    useEffect(() => {
        const getOneFintechPartner = async () => {
            try {
                const response = await axios.get(`${base_url}/api1/user/userListById`, { params: { id } });
                console.log(response.data);
                setFintechPartners([response.data]);
            } catch (error) {
                console.error("Error fetching fintech partner data:", error);
            } finally {
                setPageLoading(false);
            }
        };

        if (id) {
            getOneFintechPartner();
        }
    }, [id]);
// update start 
    const handleInputChange = (index, field, value) => {
        const updatedFintechPartners = [...fintechPartners];
        updatedFintechPartners[index] = {
            ...updatedFintechPartners[index],
            [field]: value
        };
        setFintechPartners(updatedFintechPartners);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const updatedFintechPartners = await Promise.all(
                fintechPartners.map(async (data) => {
                    try {
                        const response = await axios.put(`${base_url}/api1/user/updateUser?id=${data.id}`, data, {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                        console.log("API Response:", response.data);
                        return response.data;
                    } catch (error) {
                        console.error(`Error updating Fintech Partners with ID ${data.id}:`, error.response?.data || error.message);
                        return data; // Return original data in case of error
                    }
                })
            );

            console.log("Fintech Partners updated successfully:", updatedFintechPartners);
            setFintechPartners(updatedFintechPartners);
            window.alert('Fintech Partners updated successfully');
            navigate('/fintech/Fintech'); // Use window.location.assign for redirection
        } catch (error) {
            console.error("Error updating Fintech Partners:", error.message);
            // Handle error state or display error message to the user
        }
    };

    return (
        <>
            <div className='overviewsaa'>
                <h4>Fintech Partner Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='personalhead text-justify mt-4'>
                            <p>Fintech Partner Details</p>
                        </div>
                        { pageLoading ? <PageLoader text="Loading..." /> : fintechPartners.length > 0  ? (
                            <form onSubmit={handleSubmit}>
                                <div className='dashboardlms mt-3'>
                                    <div className='row'>
                                        <div className='col-md-12 col-lg-12'>
                                            {fintechPartners.map((data, index) => (
                                                <div className='personaldetailsinformation mb-3' key={index}>
                                                    <div className='row'>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="id">UjjawalSrijan ID</label><br />
                                                                <input type="text" name="id" id="id" value={`SCL0${data.id || ''}`} placeholder='Partner ID' onChange={(e) => handleInputChange(index, 'id', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="fintech_id">Fintech ID</label><br />
                                                                <input type="text" name="fintech_id" id="fintech_id" value={`${data.employeeId || ''}`} placeholder='Fintech ID' onChange={(e) => handleInputChange(index, 'employeeId', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="fintech_name">Partner Name</label><br />
                                                                <input type="text" name="fintech_name" id="fintech_name" value={data.employeeName || ''} placeholder='Fintech Name' onChange={(e) => handleInputChange(index, 'employeeName', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="account_number">Partner Account Number</label><br />
                                                                <input type="text" name="account_number" id="account_number" value={data.partnerAccountNumber || ''} placeholder='Partner Account Number' onChange={(e) => handleInputChange(index, 'partnerAccountNumber', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="ifsc_code">IFSC Code</label><br />
                                                                <input type="text" name="ifsc_code" id="ifsc_code" value={data.ifscCode || ''} placeholder='IFSC Code' onChange={(e) => handleInputChange(index, 'ifscCode', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="bank_name">Bank Name</label><br />
                                                                <input type="text" name="bank_name" id="bank_name" value={data.bankName || ''} placeholder='Bank Name' onChange={(e) => handleInputChange(index, 'bankName', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="processing_fee">Processing Fee</label><br />
                                                                <input type="text" name="processing_fee" id="processing_fee" value={data.processingFeePart || ''} placeholder='Processing Fee' onChange={(e) => handleInputChange(index, 'processingFeePart', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="commision">Commision</label><br />
                                                                <input type="text" name="commision" id="commision" value={data.commision || ''} placeholder='Commision' onChange={(e) => handleInputChange(index, 'commision', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="pan">PAN</label><br />
                                                                <input type="text" name="pan" id="pan" value={data.pan || ''} placeholder='PAN' onChange={(e) => handleInputChange(index, 'pan', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="cin_number">CIN Number</label><br />
                                                                <input type="text" name="cin_number" id="cin_number" value={data.cinNumber || ''} placeholder='CIN Number' onChange={(e) => handleInputChange(index, 'cinNumber', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="gst_number">GST Number</label><br />
                                                                <input type="text" name="gst_number" id="gst_number" value={data.gstNumber || ''} placeholder='GST Number' onChange={(e) => handleInputChange(index, 'gstNumber', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="director_name">Director Name</label><br />
                                                                <input type="text" name="director_name" id="director_name" value={data.directorName || ''} placeholder='Director Name' onChange={(e) => handleInputChange(index, 'directorName', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="pan_number">Director PAN</label><br />
                                                                <input type="text" name="pan_number" id="pan_number" value={data.directorPan || ''} placeholder='Director PAN' onChange={(e) => handleInputChange(index, 'directorPan', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="aadhar_number">Director Aadhaar</label><br />
                                                                <input type="text" name="aadhar_number" id="aadhar_number" value={data.directorAadhar || ''} placeholder='Director Aadhaar' onChange={(e) => handleInputChange(index, 'directorAadhar', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="spoc_name">Spoc Name</label><br />
                                                                <input type="text" name="spoc_name" id="spoc_name" value={data.spocName || ''} placeholder='Spoc Name' onChange={(e) => handleInputChange(index, 'spocName', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="spoc_phone_number">Spoc Phone Number</label><br />
                                                                <input type="text" name="spoc_phone_number" id="spoc_phone_number" value={data.spocMobileNumber || ''} placeholder='Spoc Phone Number' onChange={(e) => handleInputChange(index, 'spocMobileNumber', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="email_id">Email Id</label><br />
                                                                <input type="text" name="email_id" id="email_id" value={data.emailId || ''} placeholder='Email Id' onChange={(e) => handleInputChange(index, 'emailId', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="password">Password</label><br />
                                                                <input type="password" name="password" id="password" value={data.createPassword || ''} placeholder='Password' onChange={(e) => handleInputChange(index, 'createPassword', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="re_password">Re Password</label><br />
                                                                <input type="text" name="re_password" id="re_password" value={data.confirmPassword || ''} placeholder='Re Password' onChange={(e) => handleInputChange(index, 'confirmPassword', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-3 col-md-3 col-6'>
                                                            <div className='personaldetails text-justify mt-3'>
                                                                <label htmlFor="status">Status</label><br />
                                                                <select  name="status" id="status" value={data.status || ''} placeholder='Status' onChange={(e) => handleInputChange(index, 'status', e.target.value)}>
                                                                    <option value="Active">Active</option>
                                                                    <option value="Deactive">Deactive</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className='col-md-12 col-lg-12'>
                                            <div className='buttonss mt-5 mb-5 text-center'>
                                                <button type='submit' name='submit'>Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        ) : (
                            "No Fintech Partner details to view"
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewFintech;
